import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/ocean-technology/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function BallisticMissile() {
  const products = [
    
    "Marine Protected Area (MPA) Management Systems",
    

  ];
  const data = {
    image: "/industries/ocean-technology/marine-protected-area-management-systems.jpg", // Replace with the appropriate image URL
    intro: `Enter the realm of conservation excellence with our Marine Protected Area (MPA) Management Systems. Empower marine protected area managers and conservationists with innovative technology for effective monitoring, enforcement, and sustainable management.`,
    keyFeatures: [
      {
        title: "Geospatial Monitoring of MPAs",
        content: "Utilize geospatial monitoring to track and manage marine protected areas effectively.",
      },
      {
        title: "Enforcement and Surveillance Tools",
        content: "Equip your team with advanced tools for enforcement and surveillance to protect marine habitats.",
      },
      {
        title: "Biodiversity Tracking and Reporting",
        content: "Track biodiversity within MPAs and generate comprehensive reports for conservation initiatives.",
      },
    ],
    howItWorks: `Explore the dynamic functionalities of our MPA Management Systems. Learn how our technology integrates geospatial monitoring, surveillance tools, and biodiversity tracking to ensure the effective management and protection of marine protected areas.`,
    benefits: {
      title: "The benefits of Marine Protected Area (MPA) Management Systems",
      data: [
        "Enhanced MPA Effectiveness",
        "Improved Biodiversity Conservation",
        "Sustainable Resource Management",
      ],
    },
    industries: "Tailored for marine conservation organizations, governmental agencies, and MPA management bodies. Discover how our MPA Management Systems support diverse initiatives focused on the preservation of marine biodiversity.",
    stories: `Read about successful marine protected area management projects powered by our systems. Learn how organizations have utilized technology to enforce regulations, monitor ecosystems, and safeguard marine habitats.`,
    contactUs: `Connect with our experts to discuss how our MPA Management Systems can contribute to your marine conservation goals. Whether you're involved in MPA enforcement, research, or sustainable resource management, we have the solutions for you.`,
    futureDevelopments: `Stay informed about upcoming features and innovations in MPA management technology. Witness the evolution of tools that redefine our approach to preserving and managing marine protected areas.`,
    technology: `Learn about the compatibility of our systems with satellite data, underwater sensors, and surveillance technologies. See how our solution seamlessly integrates into existing MPA management infrastructures.`,
    support: `Access comprehensive training resources and ongoing support. Ensure that your team is well-prepared to utilize our MPA Management Systems for effective marine conservation efforts.`,
    industry: `Understand our commitment to industry standards and compliance in MPA management. Trust in the accuracy and reliability of the data provided by our systems.`,
    events: "Stay updated on events and collaborative opportunities in the field of marine conservation technology. Join us in advancing the capabilities of MPA management for the benefit of marine ecosystems.",
    blog: `Explore our blog and knowledge hub for articles, case studies, and expert insights on MPA management and marine conservation.`,
    careers: `Discover exciting career opportunities in the field of marine conservation technology. Join us in making a positive impact on the protection and sustainability of marine protected areas.`,
  };
  
  

  
  
  
  
  const content = "Embark on an oceanic technology voyage with us! Whether you're navigating advancements in marine technology, underwater exploration, environmental monitoring, or any facet of ocean technology, we offer tailored solutions. Our expertise spans projects of various scales, ensuring our ocean technology solutions align seamlessly with your objectives, budget, and scope."
    return (
    <>
    <Head>
    <title>Marine Protected Area (MPA) Management Systems | Safeguard Marine Areas | Techbrain Networks</title>
    <meta name="description" content="Techbrain Networks Marine Protected Area (MPA) Management Systems provide tools for real-time monitoring and enforcement to protect marine biodiversity and ecosystems." />
    <meta name="keywords" content="marine protected area management, MPA software, marine conservation, Techbrain Networks" />
    <meta property="og:title" content="Marine Protected Area (MPA) Management Systems | Safeguard Marine Areas | Techbrain Networks" />
    <meta property="og:description" content="Manage and protect marine biodiversity with Techbrain Networks Marine Protected Area (MPA) Management Systems, featuring real-time monitoring and enforcement." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/ocean-technology/products/marine-protected-area-management-systems" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Marine Protected Area (MPA) Management Systems" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Marine Protected Area (MPA) Management Systems | Safeguard Marine Areas" />
    <meta name="twitter:description" content="Techbrain Networks Marine Protected Area (MPA) Management Systems enable effective protection and monitoring of marine areas." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/ocean-technology/products/marine-protected-area-management-systems" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Marine Protected Area (MPA) Management Systems",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Techbrain Networks Marine Protected Area (MPA) Management Systems offer real-time monitoring and enforcement tools to protect marine biodiversity.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/ocean-technology/products/marine-protected-area-management-systems",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
                     <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#ED8D8D"} />

      <AppbarIndustry title={"Ocean and Technology"} homeLink={'/industries/ocean-technology'} link={'/industries/ocean-technology/products'} />
      <HeroSection img={"/industries/ocean-technology/marine-protected-area-management-systems.jpg"}> Marine Protected Area (MPA) Management Systems




</HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#080707",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#ED8D8D",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#ED8D8D"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
        {/* Industries */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

          

        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
           Stay informed about upcoming features and innovations in radiation shielding simulation technology
          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080707",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#ED8D8D"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#ED8D8D",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
        <Box
            sx={{
              width: [ "100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#ED8D8D"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      
      <FooterIndustry ourProducts={ourProducts} color={"#ED8D8D"} bg={"#080707"} />
    </>
  );
}

export default BallisticMissile;
